import React, { useCallback, useEffect, useMemo, useState } from "react"
import Send from "../../core/communication"
import FarmerScreen from "../../screen/FarmerScreen"
import { sort } from "fast-sort"
import moment from "moment"
import { useUsers } from "../../core/utils/hooks/useUsers"
import { useScope } from "../SelectProjectCompanyContainer"
import { useLocation, useNavigate, useResolvedPath, useSearchParams } from "react-router-dom"
import { useAssistanceResolve } from "../../core/utils/hooks/useAssistanceResolve"
import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { useFormProject } from "../../core/utils/hooks/useFormProject"
import { customToast } from "../../components/Toast"
import { getIds } from "../../core/utils/getIds"
import { removeDuplicatedArray } from "../../core/utils/manipulateArrays"
import ModalAlert from "../../components/ModalAlert"
import { store } from "../../core/redux"
import { toast } from "react-toastify"
import { getPeriodDate } from "../../core/utils/dateUtils"
import { applyFilterList } from "../../core/utils/farmerFilter/filters"
import { setData } from "../../core/redux/app/Actions"
import useKanbanDataByTags from "../../core/utils/hooks/useKanbanDataByTags"

const unRated = {
  id: "unRated",
  name: "Sem Classificação",
  projectId: "",
  color: "#ffe2c0",
  text_color: "#f44336",
  project: null,
  title: "Sem Classificação",
}

const unTagged = {
  id: "unTagged",
  name: "Sem Tag",
  projectId: "",
  color: "#ffe2c0",
  text_color: "#f44336",
  title: "Sem Tag",
}

const formattedLanes = (tags = [], users, bucketList) => {
  if (!Array.isArray(tags) || !Array.isArray(users)) {
    return {}
  }

  const generalTags = [
    "Desconexão"
  ]

  const desiredOrder = ["Sem Tag", "Sem Classificação", ...generalTags]

  const customSort = (a, b) => {
    const indexA = desiredOrder.indexOf(a.bucket)
    const indexB = desiredOrder.indexOf(b.bucket)

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB
    } else if (indexA !== -1) {
      return -1
    } else if (indexB !== -1) {
      return 1
    } else {
      return a.bucket.localeCompare(b.bucket)
    }
  }

  const bucketDescription = (bucketName) => {
    let description = "Atendimentos que foram realizados em grupo."

    if (bucketName.includes("Desconexão")) {
      description = "Produtores que não fazem parte do projeto ou não recebem mensagens."
    } else if (bucketName.includes("Cadastrados recentemente")) {
      description = "Produtores cadastrados nos últimos 3 meses, aguardando engajamento."
    } else if (bucketName.includes("Nutrição")) {
      description = "Produtores inativos, sem resposta ou atendimento nos últimos 30 dias. "
    } else if (bucketName.includes("Engajados")) {
      description = "Produtores que responderam, mas sem atendimento recente registrado."
    } else if (bucketName.includes("Com agendamento")) {
      description = "Produtores com atendimento agendado, aguardando execução."
    } else if (bucketName.includes("Com atendimento")) {
      description = "Produtores com atendimento ou coleta de dados registrada no último mês. "
    } else if (bucketName.includes("Prospecção")) {
      description = "Produtores que nunca responderam depois de 3 meses de cadastro."
    } else {
      description = ""
    }

    return description
  }

  tags = [unTagged, unRated, ...tags]

  const formatingLanes = {
    lanes:
      Array.isArray(bucketList) &&
      bucketList.map((item, index) => {
        let cards = users
          .filter((card) => item.users.find((ID) => ID === card?.id))
          .map((card) => {
            const dateTimeStamp =
              card.analytics &&
              card.analytics.event_timestamp &&
              moment(new Date(card.analytics.event_timestamp / 1000)).toDate()
            const date =
              (card.analytics &&
                card.analytics.event_timestamp &&
                moment(new Date(card.analytics.event_timestamp / 1000)).fromNow()) ||
              "Inativo"

            return {
              ...card,
              id: card.id,
              title: card.name,
              date,
              dateTimeStamp,
              description: card.email,
              generalTag: card.tag_user.find((tag) =>
                generalTags
                  .map((item) => item?.toLocaleLowerCase())
                  .includes(tag?.name?.toLocaleLowerCase()),
              ),
              tags: card.tag_user
                .map((cardTag) => ({ ...cardTag, idLinked: cardTag?.tagUserId || Math.random() }))
                .filter((tag) => tag.id !== null)
                .map(({ id, name, color, text_color, idLinked, projectId }) => ({
                  id: id,
                  title: name,
                  bgcolor: color,
                  color: text_color,
                  idLinked,
                  projectId: projectId,
                })),
            }
          })

        return {
          id: index,
          title: item.bucket,
          label: `${cards.length}`,
          cards: sort(cards).desc("dateTimeStamp"),
          bucketDescription: bucketDescription(item.bucket),
        }
      }),
  }

  return formatingLanes
}

const FarmerContainer = () => {
  const navigate = useNavigate()
  const { scope, scopeType } = useScope()
  const {
    forms: formsByProject,
    setSelectedFormId,
    setSelectedStepId,
    selectedStepId,
    steps,
    groups,
    setSelectedGroupId,
    selectedGroupId,
    groupQuestions,
  } = useFormProject()
  useAssistanceResolve(true)
  const [_, setSearchParams] = useSearchParams()
  const dispatch = useDispatch()
  const isUserAdmin = useSelector((state) => state.app?.isUserAdmin)
  const [selectedsUsers, setSelectedsUsers] = useState([])
  const [kanbanData, setKanbanData] = useState([])
  const [tagsToFilter, setTagsToFilter] = useState(false)
  const [showKanban, setShowKanban] = useState(false)
  const [tagId, setTagId] = useState("")
  const [selectedCardOnBoard, setSelectedCardOnBoard] = useState([])
  // const [filter, setFilter] = useState({})
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [openModalFilter, setOpenModalFilter] = useState(false)
  const [resetFields, setResetFields] = useState(false)
  const [isCheckAll, setIsCheckAll] = useState(() => {
    if (kanbanData?.lanes?.length > 0) {
      return kanbanData.lanes.reduce((acc, lane) => ({
        ...acc,
        [lane.id]: false
      }), {})
    }
    return {}
  })
  const [isFilterLoading, setIsFilterLoading] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  const [bucketList, setBucketList] = useState([])
  const location = useLocation()
  const [updatingUser, setUpdatingUser] = useState(false)
  const usersScreen = location.pathname === "/users"
  const [toResolveByTagsCount, setToResolveByTagsCount] = useState({
    "Desconexão": 0,
    Transformação: 0,
    Educação: 0,
    Prospecção: 0,
    "Assistência técnica": 0,
  })
  const [editCityAndStateValues, setEditCityAndStateUserValues] = useState({})

  const [progressDelete, setProgressDelete] = useState(0);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [kanbanForTags, setKanbanForTags] = useState(false)

  const { register, watch, control, setValue } = useForm({
    mode: "onChange",
  })

  const filter = useMemo(() => store.getState().app.farmerFilters || {}, [JSON.stringify(store.getState().app.farmerFilters)])

  const {
    users,
    tags,
    tagsProject,
    isLoading,
    isInitialLoading,
    isFetching,
    isRefetching,
    isFetched,
    lastUpdated,
    reload,
  } = useUsers()

  const kanbanDataByTags = useKanbanDataByTags(users, tags);

  const setFilter = useCallback((newFilter) => {
    if (typeof newFilter === "function") {
      store.dispatch({ type: "SET_DATA", payload: { farmerFilters: newFilter(filter) } });
    } else {
      store.dispatch({ type: "SET_DATA", payload: { farmerFilters: newFilter } });
    }
  }, [filter])

  const loadBucketData = async () => {
    try {
      const response = await Send.get(
        `/bigquery/status/kanban/${scope?.id}`,
        `scopeType=${scopeType}`,
      )

      const assistanceBucket = response.findIndex((item) => item.bucket === "Agendamento")

      if (assistanceBucket !== -1) {
        const [assistanceItem] = response.splice(assistanceBucket, 1)
        response.splice(response.length - 1, 0, assistanceItem)
      }

      setBucketList(response)
      return response
    } catch (error) {
      console.log("Error", error)
    }
  }

  useEffect(() => {
    if (scope && scope?.id) {
      clearValues()
      loadBucketData()
    }
  }, [scope])

  useEffect(() => {
    setSelectedsUsers([])
  }, [isFetched, isRefetching])

  useEffect(() => {
    if (filter?.tag && selectedsUsers.length > 0) {
      const users = selectedsUsers.filter((user) =>
        user.tag_user.some((tagUser) => filter?.tag?.some((tag) => tag.value === tagUser.id)),
      )
      setSelectedCardOnBoard(users?.map(({ id }) => id))
    }
    if (
      (filter?.tag && !filter.tag.length) ||
      (filter?.tagException && !filter.tagException.length)
    ) {
      setSelectedsUsers([])
      setSelectedCardOnBoard([])
      setIsCheckAll({})
    }
  }, [filter])

  useEffect(() => {
    if (resetFields) {
      setResetFields(false)
    }
  }, [resetFields])

  useEffect(() => {
    if (!filter) return

    const { tag, tagException, form, step, group, producersByForm } = filter

    if (tag) {
      setSelectedsUsers([])
      setSelectedCardOnBoard([])
      setIsCheckAll({})
    }

    setTagsToFilter(Boolean(tagException?.length))

    if (!form || !step || !group) {
      setSelectedStepId(null)
      setSelectedGroupId(null)
    }

    if (form?.value && step?.value) {
      setSelectedFormId((prev) => (prev !== form.value ? form.value : prev))
    }

    const updateFarmerFilters = (keyToNullify) => {
      store.dispatch({
        type: "SET_DATA",
        payload: { farmerFilters: { ...filter, [keyToNullify]: null } },
      })
    }

    if (!form && step?.value) updateFarmerFilters("step")
    if (!step && group?.value) updateFarmerFilters("group")
    if (!group && groupQuestions?.value) updateFarmerFilters("groupQuestion")
    if (!form?.value && producersByForm?.length) updateFarmerFilters("producersByForm", [])
  }, [filter])
  
  useEffect(() => {
    if (bucketList?.length > 0 && (scope?.id || isLoading)) {
      setKanbanData(formattedLanes(tags, users, bucketList))
      loadToResolveByTags()
    }
    setSelectedCardOnBoard([])
    setIsCheckAll({})
  }, [bucketList, scope])

  useEffect(() => {
    if (users && users.length > 0) {
      const filteredUserCardBoard = users.filter((user) =>
        selectedCardOnBoard.some((item) => item?.id === user.id),
      )
      if (filteredUserCardBoard && filteredUserCardBoard.length > 0) {
        setSelectedsUsers(filteredUserCardBoard)
      }
    }
  }, [selectedCardOnBoard])

  useEffect(() => {
    if (kanbanData?.lanes?.length > 0) {
      const newCheckAll = kanbanData.lanes.reduce((acc, lane) => ({
        ...acc,
        [lane.id]: isCheckAll[lane.id] ?? false
      }), {})
      setIsCheckAll(newCheckAll)
    }
  }, [kanbanData])

  const openModalButtons = () => {
    setModalIsOpen(true)
  }

  const reloadData = () => {
    reload()
  }

  const loadToResolveByTags = async () => {
    try {
      const response = await Send.get(
        `/assistance-to-resolve/project/${scope?.id}`,
        `scopeType=${scopeType}`,
      )
      setToResolveByTagsCount(response)
    } catch (error) {
      console.log("Error", error)
    }
  }

  const clearValues = () => {
    // setFilter({})
  }

  const onDragEnd = async (cardId, sourceLaneId, targetLaneId) => {
    if (targetLaneId === sourceLaneId) {
      return
    }

    const card = kanbanData.lanes.flatMap((item) => item.cards).find((item) => item.id === cardId)

    if (card) {
      const toRemoveTag = card.tags?.find((item) => item.id === sourceLaneId)
      const tagToLink = tags.find((item) => item.id === targetLaneId)

      if (tagToLink && tagToLink.id) {
        await Send.post("/tags-user", { users: [card], tags: [tagToLink] })
      }

      if (tagToLink?.name?.toLowerCase() === "em prospecção") {
        const tagsToRemove = card.tags?.filter((item) => !item.projectId || item.projectId === "")
        for (const item of tagsToRemove) {
          await Send.delete(`/tags-user/${item.idLinked}`)
        }
        reloadData()
      } else if (toRemoveTag) {
        await Send.delete(`/tags-user/${toRemoveTag.idLinked}`)
        reloadData()
      }
    }
  }

  const handleSelectedCardOnBoard = (e, laneId) => {
    const { checked, value } = e.target

    const lane = kanbanData.lanes.find(lane => lane.id === laneId)
    const cardUsers = lane?.cards?.map(({ id, projectId, project, name, email, whatsapp }) => ({
      id,
      projectId,
      project,
      name,
      email,
      whatsapp,
    })) || []

    if (checked) {
      setSelectedCardOnBoard(prev => [...prev, ...cardUsers.filter(card => card.id === value)])
    } else {
      setSelectedCardOnBoard(prev => prev.filter(card => card.id !== value))
    }

    setIsCheckAll(prev => {
      const newCheckAll = { ...prev }
      
      const allCardsSelected = cardUsers.every(card => 
        selectedCardOnBoard.some(selected => selected.id === card.id)
      )

      if (allCardsSelected) {
        newCheckAll[laneId] = true
      } else {
        newCheckAll[laneId] = false
      }

      return newCheckAll
    })
  }

  const handleSelectedAllCardsOnBoard = (e, cards) => {
    const { value } = e.target
    const isSelected = isCheckAll[value]

    setIsCheckAll(prev => {
      const newCheckAll = {
        ...prev,
        [value]: !isSelected
      }

      const selectedLanes = Object.entries(newCheckAll)
        .filter(([_, isSelected]) => isSelected)
        .map(([laneId]) => laneId)

      const selectedCards = selectedLanes.length > 0 
        ? kanbanData.lanes
            .filter(lane => selectedLanes.includes(String(lane.id)))
            .flatMap(lane => lane.cards)
        : []

      if (selectedCards.length > 0) {
        const mapCardFields = ({ id, projectId, project, name, email, whatsapp }) => ({
          id,
          projectId,
          project,
          name,
          email,
          whatsapp,
        })

        const cardUsers = selectedCards.map(mapCardFields)
        setSelectedsUsers(cardUsers)
        setSelectedCardOnBoard(cardUsers)
      } else {
        setSelectedsUsers([])
        setSelectedCardOnBoard([])
      }

      return newCheckAll
    })
  }

  const handleSelectedList = (data) => {
    if (Array.isArray(data)) {
      setSelectedsUsers((current) => (current.length ? [] : data))
    } else {
      const hasValueIndex = selectedsUsers.findIndex((item) => item?.id === data?.id)

      if (hasValueIndex !== -1) {
        setSelectedsUsers((current) => {
          const updatedUsers = [...current]
          updatedUsers.splice(hasValueIndex, 1)
          return updatedUsers
        })
      } else {
        setSelectedsUsers((current) => [data, ...current])
      }
    }
  }

  const handleTagsToFilter = (e) => {
    setTagsToFilter(!tagsToFilter)
  }

  const handleRemoveTag = async (id) => {
    await Send.delete(`/tags-user/${id}`)
    reloadData()
  }

  const handleQuestionsWithoutAnswerDateFilter = (value) => {
    if (value) {
      setFilter((values) => ({ ...values, ['date']: value }))
    } else {
      setFilter((values) => ({ ...values, ['date']: null }))
      //setQuestionsWithoutAnswersDateFilter()
    }
  }

  const onChangeFilter = (field, value) => {
    if (field === "date") {
      setFilter((values) => ({ ...values, [field]: value }))
      return
    } else {
      return (value) => {
        if (field === "form" && value) {
          setSelectedFormId(value?.value || value)
        } else if (field === "step" && value) {
          setSelectedStepId(value)
        } else if (field === "group" && value) {
          setSelectedGroupId([value])
        }

        setFilter((values) => ({ ...values, [field]: value }))
      }
    }
  }

  const onChangeEditCityAndState = (field, value) => {
    setEditCityAndStateUserValues((values) => ({ ...values, [field]: value }))
  }

  const handleDeleteBeneficiary = (user) => {
    ModalAlert.danger({
      title: "Excluir",
      text: "Você deseja mesmo excluir este beneficiário ?",
      confirmLabel: "Sim",
      onConfirm: async () => {
        if (user) {
          try {
            await Send.delete(`/users/${user}`)
            customToast("Beneficiário excluído com sucesso", "success")
          } catch (error) {
            console.log("error", error)
            customToast("Ocorreu um erro ao excluir o beneficiário", "error")
          } finally {
            reload()
          }
        }
      },
    })
  }

  const handleDeleteManyBeneficiaries = async (userIds) => {
    if (!userIds || userIds.length === 0) {
      customToast("Não há usuários selecionados")
      return
    }

    setLoadingDelete(true)
    const toastId = toast.loading("Excluindo beneficiário(s), aguarde...")

    try {
      const response = await Send.post("/users/delete-many", { userIds })

      const { message, deleted = [], notDeleted = [], statusCode } = response

      if (statusCode === 204) {
        toast.update(toastId, {
          render: `Beneficiário(s) excluído(s) com sucesso! (${deleted.length}/${selectedsUsers.length})`,
          type: "success",
          isLoading: false,
          autoClose: 2000,
        })
      } else {
        toast.update(toastId, {
          render: `Erro ao excluir beneficiário(s): ${message}`,
          type: "error",
          isLoading: false,
          autoClose: 3000,
        })
      }

    } catch (error) {
      const errorMessage = error.response?.message || "Erro ao excluir os usuários"
      customToast(errorMessage, "error")

      toast.update(toastId, {
        render: errorMessage,
        type: "error",
        isLoading: false,
        autoClose: 3000,
      })

    } finally {
      setLoadingDelete(false)
      reload()
      setSelectedsUsers([])
      setSelectedCardOnBoard([])
    }
  }

  const handleApplyFilter = async () => {
    if (!filter.form) {
      setOpenModalFilter(false)
      return
    }

    setIsFilterLoading(true)

    try {
      let extraProps = ""

      if (filter?.groupQuestions)
        extraProps += `&formQuestions=${getIds([filter?.groupQuestions], "value")}`
      if (filter.form) extraProps += `&forms=${getIds([filter.form], "value")}`

      const [startDate, endDate] = getPeriodDate(filter?.date, false);

      if (startDate && endDate) extraProps += `&start_date=${startDate}&end_date=${endDate}`

      const dw = await Send.get(
        "/dw/data/only-farmer-ids",
        `projects='${scope?.id}'${extraProps}&scopeType=${scopeType}`,
      )

      if (!dw) {
        throw new Error(dw)
      }

      setFilter({
        ...filter,
        producersByForm: dw,
      })

      setOpenModalFilter(false)
    } catch (error) {
      console.log("Erro ao aplicar filtro.", error)
      customToast("Erro ao aplicar filtro.", "error")
    }

    setIsFilterLoading(false)
  }

  const closeModal = () => {
    setTagId("")
    setModalIsOpen(false)
  }

  const goToPendingAssistance = () => {
    navigate("/assistance/resolve")
  }

  const clearFields = () => {
    setResetFields(true)
    setTagsToFilter(false)
    store.dispatch({ type: "SET_DATA", payload: { farmerFilters: {} } })
  }

  const openEditCityAndState = (item, location) => {
    setOpenEditModal(true)
    setTimeout(() => {
      setValue(
        "location",
        location === "state"
          ? item?.original?.state
          : item?.original?.counties || item?.original?.city,
      )

      setEditCityAndStateUserValues((values) => ({
        ...values,
        id: item?.original?.id,
        location:
          location === "state"
            ? item?.original?.state
            : item?.original?.counties || item?.original?.city,
        field: location,
      }))
    }, 20)
  }

  const handleCloseEditCityAndState = () => {
    setOpenEditModal(false)
    setValue("location", "")
    setEditCityAndStateUserValues({})
  }

  const handleUpdateUser = async () => {
    const { id, field, location } = editCityAndStateValues
    try {
      setUpdatingUser(true)
      await Send.put(`/users/${id}`, {
        [field]: location,
      })

      customToast("Campo alterado com sucesso com sucesso", "success")
    } catch (error) {
      console.log("error", error)
      customToast("Ocorreu um erro ao atualizar o campo", "error")
    } finally {
      setUpdatingUser(false)
      reload()
      handleCloseEditCityAndState()
    }
  }

  const farmerProfilePath = useResolvedPath("/farmer/profile/").pathname;

  const handleNavigateToProfile = (user) => {
    dispatch(setData({ shouldRedirectToUsers: true, cachedProjectId: user?.projectId }))
    navigate(`${farmerProfilePath}${user?.id}`, { state: { fromUsers: user } })
  }

  const applyFilterListMemo = useMemo(() => applyFilterList(users, filter, tagsToFilter), [users, filter, tagsToFilter])

  return (
    <>
      {/* <button onClick={sendToAnalytics}>enviar</button> */}
      <FarmerScreen
        {...{
          reload,
          isFetching,
          updatingUser,
          isRefetching,
          lastUpdated,
          setFilter,
          filter,
          users,
          tags,
          tagsProject: removeDuplicatedArray(tagsProject, "name"),
          tagId,
          showKanban,
          setShowKanban,
          openModalButtons,
          selectedsUsers,
          setSelectedsUsers,
          modalIsOpen,
          isLoading,
          isInitialLoading,
          reloadData,
          kanbanData,
          onDragEnd,
          selectedCardOnBoard,
          handleSelectedCardOnBoard,
          handleSelectedAllCardsOnBoard,
          handleSelectedList,
          handleRemoveTag,
          isCheckAll,
          closeModal,
          goToPendingAssistance,
          isFetched,
          control,
          register,
          watch,
          onChangeFilter,
          openModalFilter,
          setOpenModalFilter,
          toResolveByTagsCount,
          isUserAdmin,
          formsByProject,
          steps,
          groups,
          groupQuestions,
          handleApplyFilter,
          isFilterLoading,
          clearFields,
          resetFields,
          setKanbanData,
          handleTagsToFilter,
          tagsToFilter,
          usersScreen,
          handleDeleteBeneficiary,
          handleDeleteManyBeneficiaries,
          openEditCityAndState,
          setOpenEditModal,
          openEditModal,
          onChangeEditCityAndState,
          editCityAndStateValues,
          handleCloseEditCityAndState,
          handleUpdateUser,
          handleNavigateToProfile,
          handleQuestionsWithoutAnswerDateFilter,
          applyFilterListMemo,
          kanbanDataByTags,
          setKanbanForTags,
          kanbanForTags,
        }}
      />
    </>
  )
}

export default FarmerContainer
